import axios from "../plugins/parseAxios";
export class AreaAPI {
  constructor(props) { }
  static getAvailableAreas(payload) {
    return axios.post("functions/getAvailableAreas", payload);
  }
}
